<template>
    <div class="page">
        <Header disconnect="true" />

        <PasswordPopup v-if="!getUser.last_update_mdp"></PasswordPopup>
        <MobilePopup v-if="!getUser.tel_mobile && getUser.last_update_mdp && !getShowPopupMobile"></MobilePopup>

        <main class="page__main">
            <div class="content">
                <div class="content__header">
                    <div class="content__icon">
                        <span class="icon icon--light"><img src="../assets/images/ic-member.svg" /></span>
                    </div>
                    <div class="content__title">
                        <h1 class="h5">Votre participation à Constances</h1>
                    </div>
                </div>
                <div class="content__body">
                    <ProfileForm :profile-link="true" />
                    <AvailableQuestionnaires />
                    <CompleteQuestionnaires />
                    <AnalysisResults />
                    <!-- <AddressChangePopup /> -->
                </div>
            </div>
        </main>

        <Footer />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

import ProfileForm from '@/components/ProfileForm.vue'
import AvailableQuestionnaires from '@/components/AvailableQuestionnaires.vue'
import CompleteQuestionnaires from '@/components/CompleteQuestionnaires.vue'
import AnalysisResults from '@/components/AnalysisResults.vue'
import AddressChangePopup from '@/components/AddressChangePopup.vue'
import PasswordPopup from '@/components/PasswordPopup.vue'
import MobilePopup from '../components/MobilePopup.vue'

import Tools from '../tools'

export default {
    name: 'Dashboard',
    components: {
        Header,
        Footer,
        ProfileForm,
        AvailableQuestionnaires,
        CompleteQuestionnaires,
        AnalysisResults,
        AddressChangePopup,
        PasswordPopup,
        MobilePopup,
    },
    mixins: [Tools],
    methods: {
        ...mapActions(['getQuestionnaires']),
    },
    computed: {
        ...mapGetters(['getUser', 'getShowPopupMobile']),
    },
    async mounted() {
        await this.getQuestionnaires()
        ///this.initExtLinks()
    },
}
</script>
